import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import ImageBackgroundMap from "../../assets/img/background-map.jpg";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_schools_list';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSchools, toggleDrawerMobileFilterSearch} from '../../actions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import SchoolsMap from './SchoolsMap';

const styles = {
    appBar: {
        position: 'relative',
    },
    flex: {
        flex: 1,
    },
};

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class SchoolsMobileMap extends Component {
    state = {
        dialogOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    handleClickOpen = () => {
        this.setState({
            dialogOpen: true
        });
    };


    handleClickClose = () => {
        this.setState({
            dialogOpen: false
        });
    };

    handleClickFilter = () => {
        this.props.toggleDrawerMobileFilterSearch();
    };

    loadMore = (e) => {
        e.preventDefault();

        const {loading, hasMore, currentPage, search} = this.props;

        if (hasMore && !loading) {
            this.props.getSchools(
                currentPage + 1,
                false, // Page with previous results
                false, // Reset the search results / listing
                search.type,
                search.programme,
                search.degree
            );
        }
    };

    render() {
        const {classes} = this.props;

        return (
            <Fragment>
                <div className="col col-map-mobile col-12 d-block d-lg-none" style={{backgroundImage: 'url("' + ImageBackgroundMap + '")'}}>
                    <div className="row align-items-center">
                        <Button className="btn-view-map" variant="outlined" size="medium" onClick={this.handleClickOpen}>
                            <Translate id="schools_list.button_voir_carte" />
                        </Button>
                    </div>
                </div>
                <Dialog
                    fullScreen
                    open={this.state.dialogOpen}
                    onClose={this.handleClickClose}
                    TransitionComponent={Transition}
                    className="dialog-map-mobile"
                >
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={this.handleClickClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                <Translate id="schools_list.dialog_mobile_map_title" />
                            </Typography>
                            <Button color="inherit" onClick={this.handleClickFilter}>
                                <Translate id="schools_list.button_filter" />
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <div className="wrapper">
                        <SchoolsMap mobile={true}/>
                    </div>
                </Dialog>
            </Fragment>
        );
    }
}

SchoolsMobileMap.propTypes = {
    getSchools: PropTypes.func.isRequired,
    toggleDrawerMobileFilterSearch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    loading: state.schools.schoolsLoading,
    hasMore: state.schools.hasMore,
    currentPage: state.schools.currentPage,
    search: state.schools.search,
    schools: state.schools.schools,
});

export default withRouter(connect(mapStateToProps, {getSchools, toggleDrawerMobileFilterSearch})(withStyles(styles)(withLocalize(SchoolsMobileMap))));



// WEBPACK FOOTER //
// ./src/features/Schools/components/List/SchoolsMobileMap.js